import { FullPageContent } from '@/components/layout/full-page-content';
import { FindingsChart } from '@/components/pages/home/findings-chart';
import { SiteSelector } from '@/components/pages/home/site-selector';
import { ThroughputChart } from '@/components/pages/home/throughput-chart';
import { VehicleSelector } from '@/components/pages/home/vehicle-selector';
import { WhatsNew } from '@/components/pages/home/whats-new';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useMe } from '@/hooks/use-me';

import { WhiteLabelSitesDetails } from './white-label-sites-details';

export function HomePage() {
  const me = useMe();
  const featureFlag = useFeatureFlag();

  return (
    <FullPageContent scrollable testId="home-page">
      <div className="p-[3.75rem]">
        <div className="flex w-full max-w-screen-2xl flex-row items-start gap-8 2xl:gap-16">
          <div className="grid h-auto w-full grow grid-cols-1 gap-8 lg:grid-cols-2">
            <div className="lg:col-span-2">
              <h1 className="text-2xl font-bold tracking-tight text-gray-900">
                Welcome back, {me.firstName}!
              </h1>
            </div>

            {me.whiteLabel ? (
              <div className="lg:col-span-2">
                <WhiteLabelSitesDetails />
              </div>
            ) : (
              <>
                {featureFlag('alerts') ? <FindingsChart /> : null}
                {featureFlag('assets') ? <ThroughputChart /> : null}
              </>
            )}

            <div className="mt-2 lg:col-span-2">
              {me.config.type === 'mobility' ? (
                <VehicleSelector />
              ) : (
                <SiteSelector />
              )}
            </div>
          </div>

          <div className="hidden h-auto w-[400px] shrink-0 space-y-8 xl:block">
            <div className="h-[36px]" />
            <div className="space-y-4 pt-4">
              <h2 className="mt-2 text-xl font-medium tracking-tight text-gray-900">
                {me.whiteLabel ? 'SMA Updates' : 'ACCURE Updates'}
              </h2>
              <WhatsNew />
            </div>
          </div>
        </div>
      </div>
    </FullPageContent>
  );
}
